import capacitores from "../../../../assets/images/productos/bancoCapacitores/Banco capacotores.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/bancoCapacitores/Mosaico - BC1.jpeg"

import { useTranslation } from "react-i18next";

function Capacitores() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "36"],
        [t("potenciaCapacitivaMaxima"), "MVAR", "6 por modulo"],
        [t("gradoDeProteccion"), "", "IP54"],
      ]}
      datosTabla2={[]}
      nombreProducto={"Banco de Capacitores"}
      fotoProducto={capacitores}
      descripcionProducto={t("bancoCapacitores.titulo_descripcion")}
      caracteristicas={[
        t("bancoCapacitores.bullet1"),
        t("bancoCapacitores.bullet2")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20Banco%20de%20Capacitores.pdf'}
      tieneTabla2={false}
    />
  );
}

export default Capacitores;